import { Box, Button, Grid, Theme, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { AppUrl } from "../../config";
import CustomizedTable from "../../containers/CustomizedTable";
import FinancialReportingSearchForm from "../../containers/FinancialReportingSearchForm";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import { KeyValue, Query } from "../../interfaces";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "backgroundColor": theme.palette.primary.main,
    "padding": "1rem 1.5rem",
    "boxShadow": "0px 2px 5px #7c7c7c",
    "& h1, & h2": {
      color: "#ffffff",
      margin: 0,
      padding: 0,
      lineHeight: 1.72,
    },
    "& button.MuiButton-root.MuiButton-containedSecondary": {
      margin: ".5rem 0",
    },
  },
}));

interface Props {
  subHeader: string;
  appState: Query;
  updateUi: (uiField: string, uiValue: string | string[] | KeyValue[]) => void;
  includeCheckbox?: boolean;
}

export default function BuildPeerGroups({
  subHeader,
  appState,
  updateUi,
  includeCheckbox,
}: Props) {
  const history = useHistory();
  const classes = useStyles();
  const [saveGroup, setSaveGroup] = React.useState(false);
  const [dontSave, setDontSave] = React.useState(true);

  React.useEffect(() => {
    if (
      appState.ui.searchPush &&
      !appState.ui.createGroupType &&
      !includeCheckbox
    ) {
      updateUi("createGroupType", "search");
    }
  }, [
    appState.ui.createGroupType,
    appState.ui.searchPush,
    includeCheckbox,
    updateUi,
  ]);
  React.useEffect(() => {
    if (!dontSave) {
      history.push(`${AppUrl("PeerGroup")}/manage?reloadGroups=true`);
    }
  }, [dontSave, history, saveGroup]);
  const header = (
    <Box className={classes.container}>
      <Grid container>
        <Grid item xs={10}>
          <Grid item xs={12}>
            <Typography variant="h1">
              Create Custom Peer Group Definition
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h2" id="peer-group-sub-head">
              {subHeader}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="secondary"
            id="save-create"
            fullWidth
            onClick={() => {
              setSaveGroup(true);
            }}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="inherit"
            fullWidth
            id="cancel-create"
            onClick={() =>
              history.push({ pathname: `${AppUrl("PeerGroup")}/manage` })
            }
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
  useInitialPageLoad("peerGroup");

  return (
    <>
      {header}
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <FinancialReportingSearchForm
            currentApp="peerGroup"
            noHeader
            noNameCert={!includeCheckbox}
            includeMultiCert={includeCheckbox}
            initialSubmit={!appState.ui.searchPush}
            pgcApp={!includeCheckbox ? "Customized Comparisons" : ""}
          />
        </Grid>
        <Grid item xs={9}>
          <Box marginTop={"1rem"}>
            <CustomizedTable
              noCheckbox={!includeCheckbox}
              buildSearch
              externalSaveVal={saveGroup}
              externalSave={setSaveGroup}
              noErrors={setDontSave}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
